import { is_device_action_ui } from 'src/types/DeviceActionUI';
import { is_group_action_ui } from 'src/types/GroupActionUI';
import { is_notification_action_ui } from 'src/types/NotificationActionUI';
import { is_run_script_action_ui } from 'src/types/RunScriptActionUI';
import { is_enable_disable_scene_action_ui, is_play_scene_action_ui } from 'src/types/SceneActionUI';
import { format } from 'svelte-i18n';
import { get } from 'svelte/store';
import { alarms } from 'src/stores/lists/scenes-derived';
import { _init_group_actions } from '../../../../../helpers/init_group_actions';

export const getDefaultSceneData = () => {
	const do_info = { mode: 'add', type: 'action', ind: -1 };
	return {
		do_info,
		selectedAction: 1,
		translated: undefined,
		selectedDevice: {},
		selectedGroup: {},
		selectedScene: {},
		deviceAction: {
			device: {
				id: undefined,
				channel: '0',
			},
			actions: [],
			delay: {
				units: 'sec',
				value: 0,
			},
			timer: {
				units: 'sec',
				value: 0,
			},
			components: [],
		},
		notificationAction: {
			id: -1,
			name: '',
			msg: get(format)('notification_msg', { default: 'My scene triggered' }),
			msg_type: '',
			type: '',
			delay: {
				value: 0,
				units: 'sec',
			},
			already_in_current_scene: undefined,
		},
		groupAction: {
			actions: [],
			components: [],
			delay: {
				value: 0,
				units: 'sec',
			},
		},
		sceneAction: {
			option: undefined,
			delay: {
				value: 0,
				units: 'sec',
			},
		},
		alarmAction: {
			option: undefined,
			delay: {
				value: 0,
				units: 'sec',
			},
		},
		scriptAction: {
			device: {
				id: undefined,
				channel: 0,
			},
			scriptId: undefined,
			scriptName: undefined,
			command: 'start',
			roomId: '',
			scriptListDeviceKey: '',
			scriptListRealId: '',
			scriptListOptions: [],
			delay: {
				value: 0,
				units: 'sec',
			},
		},
		isValid: false,
		validStepIndex: 0,
	};
};

export const DO_WIZARD_STEPS_INDEXES = {
	ACTION_STEP: 0,
	DEVICE_STEP: 1,
	CHANGE_STATE: 2,
	DELAY_STEP: 3,
	GROUP_CHANGE_STATE: 2,
	DEVICE_DELAY_ACTION_STEP: 3,
	NOTIFY_ACTION_STEP: 1,
	NOTIFY_DELAY_ACTION_STEP: 2,
	GROUP_STEP: 1,
	GROUP_DELAY_ACTION: 3,
	SCENE_STEP: 1,
	SCENE_AS: 2,
	ALARM_STEP: 1,
	ALARM_AS: 2,
	RUN_SCRIPT_DEVICE_STEP: 1,
	RUN_SCRIPT_COMMAND_STEP: 2,
};

export const getDoTranslationType = (action, sceneData) => {
	let isValid = false;
	let isTranslation = false;
	let actionType = undefined;

	if (is_device_action_ui(sceneData.translated)) {
		isTranslation = true;
		actionType = 1;
		isValid = action === actionType;
	} else if (is_notification_action_ui(sceneData.translated)) {
		isTranslation = true;
		actionType = 2;
		isValid = action === actionType;
	} else if (
		(is_play_scene_action_ui(sceneData.translated) ||
			is_enable_disable_scene_action_ui(sceneData.translated)) &&
		get(alarms)[sceneData.translated.scene_id]
	) {
		isTranslation = true;
		actionType = 5;
		isValid = action === actionType;
	} else if (
		is_play_scene_action_ui(sceneData.translated) ||
		is_enable_disable_scene_action_ui(sceneData.translated)
	) {
		isTranslation = true;
		actionType = 4;
		isValid = action === actionType;
	} else if (is_group_action_ui(sceneData.translated)) {
		isTranslation = true;
		actionType = 3;
		isValid = action === actionType;
	} else if (is_run_script_action_ui(sceneData.translated)) {
		isTranslation = true;
		actionType = 6;
		isValid = action === actionType;
	}

	return { isValid, isTranslation, actionType };
};

/**
 * Restores the selected group and Change state components when editing.
 * GroupActionStep normally does this, but edit mode can jump straight to
 * Change state. Safe to call more than once.
 */
export function bootstrapEditedGroupAction(sceneData: any, groups: Record<string, any>) {
	if (!is_group_action_ui(sceneData.translated)) {
		return;
	}

	if (sceneData.groupAction?.components?.length > 0 && sceneData.selectedGroup?.id) {
		return;
	}

	sceneData.groupAction.actions = [...sceneData.translated.actions];
	sceneData.selectedGroup = {
		name: groups[sceneData.translated.group_id]?.name || 'unknown group',
		id: sceneData.translated.group_id,
	};

	sceneData.groupAction.components =
		typeof groups[sceneData.selectedGroup.id] !== 'undefined'
			? _init_group_actions[groups[sceneData.selectedGroup.id]?.type]?.() || []
			: [];

	if (sceneData.translated.delay !== undefined) {
		sceneData.groupAction.delay = { ...sceneData.translated.delay };
	}
}

export const SCENE_ACTIONS_WITH_DELAY_OPTION = {
	1: 'deviceAction',
	2: 'notificationAction',
	3: 'groupAction',
	4: 'sceneAction',
	5: 'alarmAction',
	6: 'scriptAction',
}; // currently all of the scene actions that support delay option
